var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.735 5.823c-.909.365-1.887.632-2.882.632-2.845-1.661-6.706.07-6.706 3.708h.001c0 1.356.856 3.215 2.194 3.67v.054c-.994.445-1.269 2.711.053 3.525v.054c-1.444.481-2.395 1.408-2.395 3.009 0 2.759 2.58 3.525 4.839 3.525 2.751 0 4.797-1.002 4.797-4.072 0-3.777-5.341-2.384-5.341-4.436 0-.723.381-1.002 1.041-1.141 2.921-.549 4.113-3.467 3.358-5.528.354-.08.698-.177 1.041-.295zm-4.949 13.116v-.001c.899 0 2.179.161 2.179 1.339 0 1.168-1.031 1.409-1.994 1.409-.915 0-2.29-.145-2.29-1.35.005-1.193 1.168-1.397 2.105-1.397zm-.169-6.937v-.001c-1.163 0-1.655-.696-1.655-1.81 0-2.641 3.226-2.614 3.226-.026-.001 1.087-.424 1.837-1.571 1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 17.277v-2.625c-.423.295-1.031.445-1.549.445-.978 0-1.153-.965-1.153-1.758v-4.88c1.677 0 2.698.054 2.698.054v-2.546h-2.698c0-.734-.027-1.467.079-2.207h-2.999c.095.546.079 1.013.079 2.207h-1.269v2.545c.883-.139.899-.054 1.269-.054v.054h-.026v4.698c0 2.33.333 4.591 3.162 4.591.794.001 1.704-.133 2.407-.524z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.492 0c-1.057 0-1.824.931-1.824 1.966 0 1.018.777 1.94 1.824 1.94 1.02 0 1.787-.937 1.787-1.94 0-1.001-.741-1.966-1.787-1.966z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.016 5.957c.095.792.085 10.699 0 11.668h2.936c-.085-.963-.095-10.886 0-11.668z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.e930c36aeca3caa8a00c170fe6b85a3e.svg";
export { ForwardRef as ReactComponent };